import { SubCompanyDto } from '../../../models/dtos/subCompany.dto';
import axios from '../../axios';

export default async function getSubCompaniesRequest(): Promise<
  SubCompanyDto[]
> {
  const response = await axios.get<SubCompanyDto[]>(
    `${process.env.REACT_APP_BASE_URL}/hedefnet/sub-company`
  );
  return response.data;
}
